var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    { staticClass: "nav-user", attrs: { href: _vm.accountProfileUrl } },
    [
      _c("SVGUser2"),
      _vm._v(" "),
      _c("transition", { attrs: { name: "show-me" } }, [
        _vm.accountLoggedIn
          ? _c("div", [
              _c("span", [_vm._v(_vm._s(_vm.$t("loginwidget.profile")))]),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.accountLoggedIn && !_vm.accountLoading
          ? _c("div", [
              _c("span", [_vm._v(_vm._s(_vm.$t("loginwidget.login")))]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }